export const SESSION_ERROR =
  "We couldn't load the secure payment form. Please try again or choose another payment method.";

const SUBMISSION_FALLBACK =
  "We couldn't submit your card. Please check your card details — including the security code (CVV) — and try again.";

// Payroc surfaces its own retry-exhaustion and gateway-shape failures verbatim; neither
// tells a patient what to do, and both are reached by a blank required field.
const OPAQUE_VENDOR_MESSAGES = [
  'Max number of retries has been reached',
  'Invalid response from the payment gateway when submitting details'
];

export const getSubmissionErrorMessage = (message) =>
  !message || OPAQUE_VENDOR_MESSAGES.includes(message) ? SUBMISSION_FALLBACK : message;

export const isConnectFailure = (message) =>
  typeof message === 'string' && message.includes('to connect');

export const getInitErrorMessage = (message) =>
  isConnectFailure(message)
    ? "Couldn't load the card form. Please try again."
    : message || "Couldn't load the payment form. Please try again.";

export const buildErrorHandler =
  ({ onSubmissionError, onInitError }) =>
  ({ type, field, message }) => {
    // A submission failure leaves the fields filled and re-enabled, so tearing the form
    // down here strands the patient with nothing to retry.
    if (type === 'submission') {
      onSubmissionError(getSubmissionErrorMessage(message));
      return;
    }

    if (isConnectFailure(message)) {
      console.warn(`Payroc hosted field failed to connect (field=${field || 'unknown'})`, {
        field,
        type,
        message
      });
    }
    onInitError(getInitErrorMessage(message), { type, field });
  };

// Payroc's own missing-field check exempts cvv unless isCvvMandatory is 'mandatory', so a
// blank cvv reaches their API, returns a 400, and the vendor silently retries it five times.
// Promoting 'enabled' (field shown and accepted) routes a blank cvv through the library's
// inline required-field error instead. 'disabled' is left alone — the vendor sets that for
// cards whose brand carries no cvv, and blocking those would be worse than the bug.
export const enforceCvvWhenAccepted = (instance) => {
  if (instance?.isCvvMandatory === 'enabled') instance.isCvvMandatory = 'mandatory';
};
